import React from 'react';
import JavascriptJquerySelectors from './JavascriptJquerySelectors.jsx';
import JavascriptJqueryHtml from './JavascriptJqueryHtml.jsx';
import JavascriptJqueryCss from './JavascriptJqueryCss.jsx';
import JavascriptJqueryDom from './JavascriptJqueryDom.jsx';

export default function JsVsJquery() {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold">JS vs jQuery</h1>
      <ul className="mt-4 list-disc ml-6">
        <li><a href='/javascript/jquery/selectors' className='underline'>jQuery Selectors</a></li>
<li><a href='/javascript/jquery/html' className='underline'>jQuery HTML</a></li>
<li><a href='/javascript/jquery/css' className='underline'>jQuery CSS</a></li>
<li><a href='/javascript/jquery/dom' className='underline'>jQuery DOM</a></li>
      </ul>
    </div>
  );
}
